'use strict';
import firebase from 'firebase/app'

export default {
  state: {
  },
  mutations: {
  },
  actions: {
    async login({dispatch},{email, password}) {
      dispatch;
      await firebase.auth().signInWithEmailAndPassword(email, password);
    }
  }
}